import { jsx as _jsx } from "react/jsx-runtime";
import { AppLink } from 'components/appLink';
export const UserLink = ({ userId, children }) => {
    return (_jsx(AppLink, Object.assign({ path: `/contacts/user/:id`, params: { path: { id: userId } } }, { children: children })));
};
